import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationCancel } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-inline-loader',
  standalone: false,
  templateUrl: './inline-loader.component.html',
  styleUrls: ['./inline-loader.component.scss']
})
export class InlineLoaderComponent implements OnInit, OnDestroy {
  inlineLoader$: Observable<any>;
  inlineLoaderAbandonCart$: Observable<any>;
  showSpinner: boolean = false;
  showExtensionMessage: boolean = false;
  showSpinnerAbandonCart: boolean = false;
  showExtensionMessageAbandonCart: boolean = false;
  routerSubscription: Subscription;
  inlineLoaderSubscription: Subscription;
  inlineLoaderAbandonCartSubscription: Subscription;

  constructor(
    private store: Store<{
      inlineLoader: any,
      inlineLoaderAbandonCart: any
    }>,
    private router: Router
  ) { }

  ngOnInit() {

    this.inlineLoader$ = this.store.select(store => store.inlineLoader);
    this.inlineLoaderAbandonCart$ = this.store.select(store => store.inlineLoaderAbandonCart);
    
    this.inlineLoaderSubscription = this.inlineLoader$.subscribe((data) => {
      if (data) {
        this.showSpinner = true;
        setTimeout(() => {
          this.showExtensionMessage = true;
        }, 2000);
      } else {
        // Hide immediately when state is false (no delay)
        this.showSpinner = false;
        this.showExtensionMessage = false;
      }
      console.log('INLINE LOADER DATA', data);
    })

    // Listen for navigation cancellation to hide loader immediately
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationCancel))
      .subscribe(() => {
        // Force hide immediately when navigation is cancelled
        this.showSpinner = false;
        this.showExtensionMessage = false;
        this.showSpinnerAbandonCart = false;
        this.showExtensionMessageAbandonCart = false;
      });

    this.inlineLoaderAbandonCartSubscription = this.inlineLoaderAbandonCart$.subscribe((data) => {
      if (data) {
        this.showSpinnerAbandonCart = true;
        setTimeout(() => {
          this.showExtensionMessageAbandonCart = true;
        }, 2000);
      } else {
        this.showSpinnerAbandonCart = false;
        setTimeout(() => {
          this.showExtensionMessageAbandonCart = false;
        }, 2000);
      }
    })
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.inlineLoaderSubscription?.unsubscribe();
    this.inlineLoaderAbandonCartSubscription?.unsubscribe();
  }
}
